import React, {Component} from "react";
import {Col, Row} from 'antd';
import PropTypes from "prop-types";

/**
 * 导航栏目详情
 */
class ViewForm extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {initViewFormData} = this.props || {};
        return (
            <div>
                <Row style={{marginBottom: '10px', fontSize: '16px'}}><b>导航栏目信息</b></Row>
                <Row style={{fontSize: '14px', lineHeight: 1.5, marginBottom: '10px'}}>
                    <Col span={12} style={{textAlign: 'left'}}><b>栏目名称：</b>{initViewFormData.LMMC}</Col>
                    <Col span={12} style={{textAlign: 'left'}}><b>导航栏项类型：</b>{initViewFormData.LMLXMC}</Col>
                </Row>
                <Row style={{fontSize: '14px', lineHeight: 1.5, marginBottom: '10px'}}>
                    <Col span={12} style={{textAlign: 'left'}}><b>模块标志：</b>{initViewFormData.DHLMMKBZ}</Col>
                    <Col span={12} style={{textAlign: 'left'}}><b>分类标志：</b>{initViewFormData.DHLMFLBT}</Col>
                </Row>
                <Row style={{fontSize: '14px', lineHeight: 1.5, marginBottom: '10px'}}>
                    <Col span={12} style={{textAlign: 'left'}}><b>栏目属性：</b>{initViewFormData.LMSXMC}</Col>
                    <Col span={12} style={{textAlign: 'left'}}><b>栏目链接：</b>{initViewFormData.LMLJ}</Col>
                </Row>
                <Row style={{fontSize: '14px', lineHeight: 1.5, marginBottom: '10px'}}>
                    <Col span={12} style={{textAlign: 'left'}}><b>父栏目：</b>{initViewFormData.FLMMC}</Col>
                    <Col span={12} style={{textAlign: 'left'}}><b>默认栏目：</b>{initViewFormData.MRLMMC}</Col>
                </Row>
                <Row style={{fontSize: '14px', lineHeight: 1.5, marginBottom: '10px'}}>
                    <Col span={12} style={{textAlign: 'left'}}><b>显示方式：</b>{initViewFormData.XSFSMC}</Col>
                    <Col span={12} style={{textAlign: 'left'}}><b>状态：</b>{initViewFormData.DHLMZT}</Col>
                </Row>
                <Row style={{fontSize: '14px', lineHeight: 1.5, marginBottom: '10px'}}>
                    <Col span={12} style={{textAlign: 'left'}}><b>排序号：</b>{initViewFormData.PXH}</Col>
                </Row>
            </div>
        )
    }
}

ViewForm.propTypes = {
    initViewFormData: PropTypes.object
};

export default ViewForm;


// WEBPACK FOOTER //
// ./components/fwwgl/dhlm/ViewForm.js